import React from 'react';
import PropTypes from 'prop-types';
import * as actItem from 'actions/library/item';
import { connect } from 'react-redux';
import ConfirmActionModal from 'components/ConfirmActionModal';
import {
  ContentWrapper,
  LeftColumnWrapper,
  RightColumnWrapper,
  PageWrapper,
} from 'components/wrappers/pages';
import { browserHistory } from 'react-router';
import { isDirty, getFormValues, formValueSelector } from 'redux-form';
import { askConfirmAction } from 'actions/confirm-action';
import { push } from 'react-router-redux';
import NoDataAndLoading from 'components/NoDataAndLoading';
import ConfirmModal from 'components/ConfirmModal';
import * as clevertapLibraryList from 'clevertap/library/list';
import { LIBRARY_VALIDATION_NAME_MESSAGE } from 'actions/library/item/constants';
import './Item.css';
import Pusher from 'pusher-js';
import { PUSHER_APP_KEY } from 'api/constants';
import * as action from 'actions';
import isMokaposUser from 'selectors/isMokaposUser';
import ItemDetail from './ItemDetail';
import ItemImportModal from './ItemImportModal';
import List from './List';
import ActionBar from './ActionBar';
import SettingHyperLink from './List/SettingHyperlink';

class Item extends React.Component {
  componentDidMount() {
    this.pusher = new Pusher(PUSHER_APP_KEY, {
      cluster: 'ap1',
      encrypted: true,
    });
    this.props.dispatch(actItem.pageRequest());
    browserHistory.listenBefore(location => {
      if (this.props.isDirtyItem && !this.props.nextAction) {
        this.props.dispatch(askConfirmAction(push(location)));
        return false;
      }
    });
  }

  componentDidUpdate() {
    const { dispatch, itemExportState } = this.props;
    if (itemExportState.exporting) {
      const {
        asyncJobCreated,
        asyncJobId,
        pusherChannel,
        pusherEvent,
      } = itemExportState;
      if (asyncJobCreated) {
        this.channel = this.pusher.subscribe(pusherChannel);
        this.channel.bind(pusherEvent, data => {
          if (
            asyncJobId &&
            data.resource_id &&
            asyncJobId === data.resource_id &&
            data.success &&
            data.type === 'export-done'
          ) {
            dispatch(actItem.itemExportFinished());
            dispatch(action.showLoadingSpinner(false));
            window.location.href = data.url_path;
          } else if (
            asyncJobId &&
            data.resource_id &&
            asyncJobId === data.resource_id &&
            !data.success
          ) {
            dispatch(actItem.itemExportError(data));
          }
        });
      } else {
        dispatch(
          actItem.itemExportError({
            message: 'Item export task creation failed.',
          })
        );
      }
    } else if (this.channel) {
      this.channel.unbind();
      this.channel = null;
    }
  }

  componentWillUnmount() {
    this.props.dispatch(actItem.closeRightColumn());
  }

  render() {
    const { mokapayMode } = this.props;
    const {
      library,
      loadingSpinner,
      search,
      showValidateSaveToAllWarningModal,
    } = this.props.data;
    const { openRightColumn, showImportModal, items } = library.item;
    const { showLoadingSpinnerPage } = loadingSpinner;
    return (
      <PageWrapper>
        <ActionBar
          onClickImport={this._onClickImport}
          onClickExport={this._onClickExport}
          mokapayMode={mokapayMode}
        />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={
                items.meta === undefined || items.meta.total_count === 0
              }
              title="No Data To Display"
              description=""
              linkLabel="Create Item Manually"
              linkUrl="https://mokaposhelp.zendesk.com/hc/id/articles/900000454306-Cara-Membuat-Barang"
            />
            {!showLoadingSpinnerPage && <List mokapayMode={mokapayMode} />}
            <SettingHyperLink />
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <ItemDetail mokapayMode={mokapayMode} />
          </RightColumnWrapper>
        </ContentWrapper>
        <ItemImportModal
          show={showImportModal}
          dispatch={this.props.dispatch}
          selectedOutletIds={search ? search.outletIds : []}
          search={this.props.data.search}
          user={this.props.data.user}
          outlets={this.props.data.library.item.outlets}
          categories={this.props.data.categories}
          inventories={this.props.data.inventories}
        />
        <ConfirmActionModal />
        <ConfirmModal
          showModal={showValidateSaveToAllWarningModal}
          title="Save to all Outlets"
          description={`You can't save this item to all outlets because ${this._validationMessage()} Save to this outlet only?`}
          onConfirm={this._onConfirmSavetoCurrentOutletOnly}
          confirmTitle="Yes"
          onHide={this._onCancelSavetoAllOutlets}
          cancelTitle="No"
          baseColor="danger"
        />
      </PageWrapper>
    );
  }

  _onClickExport = () => {
    const dataLibrary = this.props.data;
    const {
      library,
      user,
      search: { outletIds },
    } = dataLibrary;
    const { item } = library;
    const {
      filterState: { keyword },
    } = item;
    const prefix = 'Item Library - ';
    const { categoryId, typeInventoryId } = this.props.filterForm;
    clevertapLibraryList.libraryItemExport();
    const category_id =
      categoryId === '0' || categoryId === null ? '' : categoryId;
    const params = {
      category_id,
      inventory: !parseInt(typeInventoryId)
        ? 'all'
        : typeInventoryId === '1'
        ? 'low'
        : 'out',
      keyword: keyword || '',
      outletId: outletIds[0],
    };

    this.props.dispatch(
      actItem.itemExportRequest(
        prefix,
        user.email,
        item.outlets,
        outletIds[0],
        params
      )
    );
  };

  _onClickImport = () => {
    this.props.dispatch(actItem.showImportModal());
  };

  _onConfirmSavetoCurrentOutletOnly = () => {
    const {
      item: { items, itemDetail, outlets },
      salesType,
    } = this.props.data.library;
    const { search, newItemForm, user } = this.props.data;
    const { dispatch, file } = this.props;

    const values = newItemForm;

    // add modifier ids value and remove active_modifiers for the api
    values.modifier_ids = values.active_modifiers.map(am => {
      return am.id;
    });

    // update updated at
    // kode ini ngikut yang di moka-rails aja, di https://github.com/mokapos/moka-rails/blob/306f092dce63619cf18ab7385006f4836045159f/app/assets/javascripts/moka/services/api.js#L1003

    // we must delete the 'action' property so it doesn't sent to server.
    const allOutlet = false;

    const inStock = [];

    // we must delete the in_stock value to prevent overwriting the data
    values.item_variants.forEach(iv => {
      inStock.push(iv.in_stock == null ? 0 : parseInt(iv.in_stock, 10));
      if (!iv.is_editable) {
        delete iv.in_stock;
      }
    });

    // if it is create, the api wants 'remote_image_url' to be sent
    if (!values.id) {
      if (values.image && values.image.url) {
        values.remote_image_url = values.image.url;
      } else {
        values.remote_image_url = '';
      }
    }

    if (values.id) {
      dispatch(
        actItem.submitFormUpdate(
          values.id,
          { item: values },
          allOutlet,
          items,
          salesType,
          itemDetail,
          user,
          inStock,
          file
        )
      );
    } else {
      // ini nambahin juga, kelupaan, emang harusnya nambahin pas create seperti di moka-rails
      // kode ini ngikut yang dev aja, di https://github.com/mokapos/moka-rails/blob/306f092dce63619cf18ab7385006f4836045159f/app/assets/javascripts/moka/services/api.js#L985
      dispatch(
        actItem.submitFormCreate(
          { item: values },
          allOutlet,
          items,
          search,
          salesType,
          user,
          outlets,
          inStock,
          file
        )
      );
    }

    this.props.dispatch(actItem.setValidationModal(false));
    this.props.dispatch(
      actItem.setValidationModalMessage(
        LIBRARY_VALIDATION_NAME_MESSAGE.NO_ERROR
      )
    );
  };

  _onCancelSavetoAllOutlets = () => {
    this.props.dispatch(actItem.setValidationModal(false));
    this.props.dispatch(
      actItem.setValidationModalMessage(
        LIBRARY_VALIDATION_NAME_MESSAGE.NO_ERROR
      )
    );
  };

  _validationMessage = () => {
    const { validationModalMessage } = this.props.data;
    let message = '';

    if (validationModalMessage) {
      if (
        validationModalMessage ===
        LIBRARY_VALIDATION_NAME_MESSAGE.NAME_NOT_UNIQUE
      ) {
        message = 'the item name is already existed in other outlet(s).';
      } else if (
        validationModalMessage ===
        LIBRARY_VALIDATION_NAME_MESSAGE.SALES_TYPE_NOT_EXIST
      ) {
        message = 'not all sales types existed in other outlet(s).';
      } else if (
        validationModalMessage === LIBRARY_VALIDATION_NAME_MESSAGE.BOTH
      ) {
        message =
          'the item name is already existed in other outlet(s) and not all sales types existed in other outlet(s).';
      }
    }

    return message;
  };
}

Item.propTypes = {
  mokapayMode: PropTypes.bool,
};

Item.defaultProps = {
  mokapayMode: false,
};

const selector = formValueSelector('search');

function mapStateToProps(state) {
  const { categories, inventories } = state.library.item;
  const { file } = state.uploadImage.uploadImage;
  const { categoryId, typeInventoryId, search, outletIds } = selector(
    state,
    'categoryId',
    'typeInventoryId',
    'search',
    'outletIds'
  );
  const { cloneOutletId } = state.outletPages.list;

  // only fetch some state
  return {
    mokapayMode: !isMokaposUser(state),
    data: {
      library: {
        item: state.library.item,
        salesType: state.library.salesType.salesType,
      },
      outlet: state.outlet,
      category: state.category,
      user: state.moka.user,
      loadingSpinner: state.loadingSpinner,
      search: getFormValues('search')(state),
      newItemForm: getFormValues('item')(state),
      showValidateSaveToAllWarningModal:
        state.library.item.showValidateSaveToAllWarningModal,
      validationModalMessage: state.library.item.validationModalMessage,
      categories,
      inventories,
      file,
    },
    buttons: state.buttons,
    uploaders: state.uploaders,
    nextAction: state.confirmAction.nextAction,
    isDirtyItem: isDirty('item')(state),
    itemExportState: state.library.item.itemExportState,
    filterForm: { categoryId, typeInventoryId, search, outletIds },
    cloneOutletId,
  };
}

export default connect(mapStateToProps)(Item);
